/* @ngInject */

export default (CertificateOfTitle, TypeOfCertificateOfTitle) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function TitleDetail(idSecurity, titleType, title, volume, lot, folio, plan) {
    this.idSecurity = idSecurity;
    this.titleType = titleType;
    this.title = title;
    this.volume = volume;
    this.lot = lot;
    this.folio = folio;
    this.plan = plan;
  }

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  TitleDetail.Blank = function (idSecurity) {
    return TitleDetail.Build({
      idSecurity,
      titleType: TypeOfCertificateOfTitle.none,
      title: CertificateOfTitle.none,
      volume: 0,
      lot: 0,
      folio: 0,
      plan: ''
    });
  };
  TitleDetail.Build = function (data) {
    return new TitleDetail(
      data.idSecurity ? data.idSecurity : '',
      TypeOfCertificateOfTitle.of(data?.titleType?.name || data?.titleType?.toString()),
      CertificateOfTitle.of(data?.title?.name || data?.title?.toString()),
      data.volume ? data.volume : 0,
      data.lot ? data.lot : 0,
      data.folio ? data.folio : 0,
      data.plan ? data.plan : ''
    );
  };

  return TitleDetail;
};
